import {
  useRampFlagBaselineRuns,
  useRampFlagPinnedRuns,
} from '../../../util/rampFeatureFlags';
import {WBTableRowWithRunSetInfo} from '../../../util/tablecols';
import {useCurrentRunSet} from '../RunSelectorRunSetContext';
import {isRunBaseline, isRunPinned} from '../util';

export function useRowPinningState(row: WBTableRowWithRunSetInfo) {
  const runSet = useCurrentRunSet();
  const isBaselineEnabled = useRampFlagBaselineRuns();
  const isPinnedRunsEnabled = useRampFlagPinnedRuns();

  return {
    isRunPinned: isPinnedRunsEnabled && isRunPinned(runSet.pinnedRunIds, row),
    isRunBaseline:
      isBaselineEnabled &&
      isPinnedRunsEnabled &&
      isRunBaseline(runSet.baselineRunId, row),
  };
}
